define(['underscore', './LookupAddressState', './AddressListState', './ZipLookupState', './EditAddressState', './AddressInfoState', './LookupFailureState'],
    (_, lookupAddressState, addressListState, zipLookupState, editAddressState, addressInfoState, lookupFailureState) =>
        (LocaleService, AddressLookupService, AvailabilityService, tileModel) => {
            let state = undefined;
            const dto = tileModel.viewModel.policyAddress;

            function toLookup() {
                state = {
                    'id': 'lookupAddress',
                    'data': lookupAddressState(AddressLookupService, {
                        initialAddress: '',
                        onLookup: toAddressList,
                        onNoResult: () => toZipLookup({failure: 'noMatch'}),
                        onLookupFail: () => toLookupFailure({failure: 'lookupUnavailable'})
                    })
                };
            }

            function toLookupFailure(error = {}) {
                state = {
                    'id': 'lookupFailure',
                    'data': lookupFailureState({
                        error,
                        onConfirm: () => toAddressInput(dto.value)
                    })
                };
            }


            function toAddressList(addresses) {
                const returnFunc = () => toAddressList(addresses);
                const nextFunc = () => toConfirmation(()=> toAddressInput(dto.value));
                state = {
                    'id': 'addressList',
                    'data': addressListState({
                        addresses,
                        onAddress(addr) {
                            dto.value = _.clone(addr.address);
                            if (!dto.country.value) {
                                dto.country.value = getCountryCode();
                            }
                            checkAvailability(returnFunc, nextFunc);
                        },
                        onNewAddress: toZipLookup
                    })
                };
            }


            function toZipLookup(error = {}) {
                const returnFunc = () => toStreetInput();
                const nextFunc = () => autofillBasedOnPostcode();
                dto.value = {};
                state = {
                    'id': 'zipLookup',
                    'error': error,
                    'data': zipLookupState(AddressLookupService, {
                        zipDto: dto.postalCode,
                        onLookup() {
                            checkAvailability(returnFunc, nextFunc);
                        },
                        onLookupFail() {
                            toLookupFailure({failure: 'lookupUnavailable'});
                        }
                    })
                };
            }


            function toAddressInput(prefill = {}) {
                const returnFunc = () => toAddressInput(dto.value);
                const nextFunc = () => toConfirmation(returnFunc);
                dto.value = prefill;
                dto.country = getCountryCode();
                state = {
                    'id': 'addressInput',
                    'data': editAddressState({
                        dto,
                        onDone() {
                            checkAvailability(returnFunc, nextFunc);
                        },
                        onCancel: () => {
                            clearObject(dto.value);
                            toLookup();
                        },
                        onInvalid() {
                            toInvalid(() => toAddressInput(dto.value));
                        }
                    })
                };
            }


            function toStreetInput(prefill = {}) {
                const returnFunc = () => toStreetInput(dto.value);
                const nextFunc = () => toConfirmation(returnFunc);
                dto.value = prefill;
                dto.country = getCountryCode();
                state = {
                    'id': 'streetInput',
                    'data': editAddressState({
                        dto,
                        onDone() {
                            checkAvailability(returnFunc, nextFunc);
                        },
                        onCancel: () => {
                            clearObject(dto.value);
                            toLookup();
                        },
                        onInvalid() {
                            toInvalid(() => toStreetInput(dto.value));
                        }
                    })
                };
            }


            function toConfirmation(onBack) {
                state = {
                    'id': 'complete',
                    'data': addressInfoState({
                        dto,
                        isCancellable: () => !tileModel.isLocked,
                        onCancel: onBack
                    })
                };
            }

            function toInvalid(onBack, errorState = {}) {
               state = {
                    'id': 'addressInvalid',
                    'data': addressInfoState({
                        dto,
                        errorState: errorState,
                        isCancellable: () => !tileModel.isLocked,
                        onCancel: onBack
                    })
                };
            }

            function checkAvailability(onBack, onNext) {
                const data = preparePostCodeData();

                const availabilityPromise = AvailabilityService.checkAvailabilityBasedOnPostalCode(null, data);
                availabilityPromise.then(
                    availabilityResp => {
                        if (!availabilityResp.isAvailable) {
                            toInvalid(onBack);
                        } else {
                            onNext();
                        }
                    },
                    () => toInvalid(onBack)
                );
            }

            function autofillBasedOnPostcode() {
                const data = preparePostCodeData();

                AddressLookupService.autofillBasedOnPostalCode('quoteandbind', data).then(
                    (addressInfo) => {
                        _.mapObject(_.max(addressInfo.matches, (match) => {return match.matchAccuracy;}).address, (value, key) => {
                            if (key !== 'addressLine1') {
                                dto[key].value = value;
                            }
                        });
                        toStreetInput(dto.value);
                    },
                    () => toLookupFailure({failure: 'lookupUnavailable'})
                );
            }

            function preparePostCodeData() {
                const data = {
                    agentportalnewsubmission: null,
                    effectiveDate: new Date(),
                    postalCode: tileModel.viewModel.policyAddress.postalCode.value,
                    productCode: tileModel.viewModel.productCode.value,
                    quoteID: null
                };
                return data;
            }

            function clearObject(dtoObject) {
                Object.keys(dtoObject).forEach((key) => {
                    dtoObject[key] = '';
                });
            }

            function getCountryCode() {
                return LocaleService.getCountry().code;
            }

            toLookup();

            return {
                get state() {
                    return state;
                },
                get isComplete() {
                    return state.id === 'complete';
                }
            };
        }
);


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/address/models/AddressTile.js
 **/